import CopyButton from './CopyButton';

interface Props {
  title: string;
  children: React.ReactNode;
  copyValue?: string | null;
}

export default function Metadata(props: Props) {
  const { title, children, copyValue } = props;

  return (
    <div className="mb-2 last:mb-0">
      <div className="flex items-start gap-0.5">
        <div className="overflow-hidden text-12 break-words text-muted-foreground">
          {title}
        </div>
        {!!copyValue && (
          <div className="mt-0.5 ml-0.5 h-1.5 w-1.5 shrink-0 text-foreground">
            <CopyButton value={copyValue} />
          </div>
        )}
      </div>
      <div className="w-full overflow-hidden text-14 break-words">
        {children}
      </div>
    </div>
  );
}
